import React, { useState, useEffect } from 'react';

export default function JsonInput({ data, header, changeValue, extra }) {
    const [text, setText] = useState(JSON.stringify(data || {}, null, 2));
    const [error, setError] = useState('');
    useEffect(() => { setText(JSON.stringify(data || {}, null, 2)); setError(''); }, [data]);
    return <div className="w-100"><textarea className="w-100 transpanet-input" rows={18} aria-label={header.information?.label || 'Structured content'} value={text} onChange={event => {
        setText(event.target.value);
        try { const value = JSON.parse(event.target.value); if (!value || typeof value !== 'object') throw new Error(); setError(''); changeValue(header.key, value, extra); }
        catch { setError('Enter valid JSON. The last valid content will be saved.'); }
    }} style={{ fontFamily: 'monospace' }} />{error && <p role="alert">{error}</p>}</div>;
}
